import React, { useEffect } from "react";
import { Dna } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "../css/main.css";
import { getOrderId } from "../redux/action";

function OrderId() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.OrderId);
  const get = data ?? false;
  useEffect(() => {
    dispatch(getOrderId(state));
  }, []);
  return (
    <div>
      {loading ? (
        <div className="mt-32 flex justify-center">
          <Dna
            visible={true}
            height="150"
            width="150"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : error ? (
        <div className="flex justify-center">
          <div className="alert alert-error shadow-lg w-8/12 mt-20">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current flex-shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>Error! Task failed successfully.</span>
            </div>
          </div>
        </div>
      ) : get?.orderItems ? (
        <div className="pt-20 pb-24 text-slate-100">
          {get?.orderItems?.map((item, index) => {
            return (
              <div className="item mb-5" key={index}>
                <div className="flex justify-center">
                  <div className="w-11/12">
                    <div className="w-full bg-gradient-to-r from-violet-900 to-indigo-900 block lg:flex lg:justify-start p-5 transition duration-700 rounded-xl">
                      <div className="w-full lg:w-2/12 md:ml-0 flex justify-center items-center">
                        <div className="bg-white w-20 lg:w-44 h-20 lg:h-44 flex justify-center items-center overflow-hidden rounded-lg shadow-xl">
                          <img
                            className="w-4/12 lg:w-6/12"
                            src={item.product.image}
                            alt="image"
                          />
                        </div>
                      </div>
                      <div className="sm:flex sm:justify-star w-full">
                        <div className="w-full mt-5 sm:mt-0 block md:ml-10">
                          <div className="block lg:flex lg:justify-start w-full">
                            <div className="block w-full justify-start lg:w-8/12 xl:w-9/12">
                              <div className="text-sm sm:text-lg my-5 lg:text-md flex justify-start w-full items-center overflow-auto">
                                <span className="text-sm sm:text-lg lg:text-xl font-semibold text-teal-500 mr-2">
                                  Order Number:
                                </span>
                                {item.product.name}
                              </div>
                              <div className="text-sm sm:text-lg my-5 lg:text-md flex justify-start w-full items-center">
                                <span className="text-sm sm:text-lg lg:text-xl font-semibold text-teal-500 mr-2">
                                  brand:
                                </span>
                                {item.product.brand}
                              </div>
                              <div className="text-sm sm:text-lg my-5 lg:text-md flex justify-start w-full items-center">
                                <span className="text-sm sm:text-lg lg:text-xl font-semibold text-teal-500 mr-2">
                                  category:
                                </span>
                                {item.product.category}
                              </div>
                              <div className="text-sm sm:text-lg my-5 lg:text-md flex justify-start w-full items-center">
                                <span className="text-sm sm:text-lg lg:text-xl font-semibold text-teal-500 mr-2">
                                  color:
                                </span>
                                {item.product.color}
                              </div>
                              <div className="text-sm sm:text-lg my-5 lg:text-md flex justify-start w-full items-center">
                                <span className="text-sm sm:text-lg lg:text-xl font-semibold text-teal-500 mr-2">
                                  countInStock:
                                </span>
                                {item.product.countInStock}
                              </div>
                            </div>
                            <div className="block w-full justify-start lg:w-8/12 xl:w-3/12">
                              <div className="text-sm sm:text-lg my-5 lg:text-md flex justify-start w-full items-center">
                                <span className="text-sm sm:text-lg lg:text-xl font-semibold text-teal-500 mr-2">
                                  numReviews:
                                </span>
                                {item.product.numReviews}
                              </div>
                              <div className="text-sm sm:text-lg my-5 lg:text-md flex justify-start w-full items-center">
                                <span className="text-sm sm:text-lg lg:text-xl font-semibold text-teal-500 mr-2">
                                  rating:
                                </span>
                                {item.product.rating}
                              </div>
                              <div className="text-sm sm:text-lg my-5 lg:text-md flex justify-start w-full items-center">
                                <span className="text-sm sm:text-lg lg:text-xl font-semibold text-teal-500 mr-2">
                                  price:
                                </span>
                                {item.product.price} $
                              </div>
                              <div className="text-sm sm:text-lg my-5 lg:text-md flex justify-start w-full items-center">
                                <span className="text-sm sm:text-lg lg:text-xl font-semibold text-teal-500 mr-2">
                                  Order Number:
                                </span>
                                <span className="overflow-auto">
                                  {item.qty}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="text-sm sm:text-lg my-5 lg:text-md flex justify-start w-full items-center">
                            <span className="text-sm sm:text-lg lg:text-xl font-semibold text-teal-500 mr-2">
                              description:
                            </span>
                            <span className="overflow-auto">
                              {item.product.description}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          <div className="item">
            <div className="flex justify-center">
              <div className="w-11/12">
                <div className="w-full block lg:flex lg:justify-start bg-gradient-to-r from-violet-900 to-indigo-900 p-5 transition duration-700 rounded-xl">
                  <div className="w-full lg:w-8/12 2xl:w-9/12">
                    <div className="flex justify-start items-center  text-sm sm:text-lg mb-5 w-full">
                      <label className="mb-2 flex text-teal-500 font-semibold text-xl">
                        City:
                      </label>
                      <label className="ml-2 h-10 flex justify-start items-center overflow-auto">
                        {get && get.shippingAddress?.city}
                      </label>
                    </div>
                    <div className="flex justify-start items-center text-sm sm:text-lg mb-5">
                      <label className="mb-2 flex text-teal-500 font-semibold text-xl">
                        Address:
                      </label>
                      <label className="ml-2 h-10 flex justify-start items-center overflow-auto">
                        {get && get.shippingAddress?.address}
                      </label>
                    </div>
                    <div className="flex justify-start items-center text-sm sm:text-lg mb-5">
                      <label className="mb-2 flex text-teal-500 font-semibold text-xl">
                        Postal Code:
                      </label>
                      <label className="ml-2 h-10 flex justify-start items-center overflow-auto">
                        {get && get.shippingAddress?.postalCode}
                      </label>
                    </div>
                    <div className="flex justify-start items-center text-sm sm:text-lg mb-5">
                      <label className="mb-2 flex text-teal-500 font-semibold text-xl">
                        Phone Number:
                      </label>
                      <label className="ml-2 h-10 flex justify-start items-center overflow-auto">
                        {get && get.shippingAddress?.phone}
                      </label>
                    </div>
                  </div>
                  <div className="w-full lg:w-4/12 2xl:w-3/12">
                    <div className="flex justify-start items-center text-sm sm:text-lg mb-5">
                      <label className="mb-2 flex text-teal-500 font-semibold text-xl">
                        TotalPrice:
                      </label>
                      <label className="ml-2 h-10 flex justify-start items-center overflow-auto">
                        {get && get.totalPrice} $
                      </label>
                    </div>
                    <div className="flex justify-start items-center text-sm sm:text-lg mb-5">
                      <label className="mb-2 flex text-teal-500 font-semibold text-xl">
                        shipping Price:
                      </label>
                      <label className="ml-2 h-10 flex justify-start items-center overflow-auto">
                        {get && get.shippingPrice} $
                      </label>
                    </div>
                    <div className="flex justify-start items-center text-sm sm:text-lg mb-5">
                      <label className="mb-2 flex text-teal-500 font-semibold text-xl">
                        Payment Method:
                      </label>
                      <label className="ml-2 h-10 flex justify-start items-center overflow-auto">
                        {get && get.paymentMethod}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="item">
            <div className="flex justify-center">
              <div className="item w-11/12">
                <div className="w-full bg-gradient-to-r m-2 p-5 rounded-xl">
                  <div>
                    <div className="flex justify-evenly">
                      <button
                        id="edit"
                        className="btn btn-accent bg-indigo-800 hover:bg-indigo-600 border-2 sm:w-5/12 lg:w-3/12 text-slate-100"
                        onClick={() => navigate("/Orders")}
                      >
                        back to Orders
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-60 text-xl md:text-4xl text-red-800 font-semibold">
          Your orders are empty
        </div>
      )}
    </div>
  );
}

export default OrderId;
